import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { config } from '../../function/config'
import { toast } from 'react-toastify'
import { FaUserCheck } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import AdminHeader from './AdminHeader'

export default function PendingEnquiries() {
    const navigate = useNavigate()
    const token = localStorage.getItem('token')

    const [donEnq, setDonEnq] = useState([])
    const [telecaller, setTelecaller] = useState([])

    const [loading, setLoading] = useState(false)
    const [selectedTelecallers, setSelectedTelecallers] = useState('')

    const fetchDonaionEnquiries = async() => {
      try{
        const res = await axios.get(`${config.baseurl}get_unassigned_donation_enquiries/`, {
          headers:{
            'Content-Type':'application/json',
            'Authorization':`Token ${token}`
          }
        })
        console.log('All Pending Donaion Enquiries res:', res.data)

        if(res.status === 200){
          setDonEnq(res.data.data)
        }else{
          toast.error('Fails to fetch Donation Enquiries')
        }
      }catch(error){
        console.error('Error:', error.response?.data || error)

        const message =
          error.response?.data?.message ||
          error.response?.data?.error ||
          'Failed to fetch department'

        toast.error(message)
      }
    }

    const fetchTelecaller = async() => {
      try{
        const res = await axios.get(`${config.baseurl}get_all_telecaller/`, {
          headers:{
            'Content-Type':'application/json',
            'Authorization':`Token ${token}`
          }
        })
        console.log('All Staffs:', donEnq)

        if(res.status === 200){
          setTelecaller(res.data.data)
        }else{
          toast.error('Fails to fetch telecallers')
        }
      }catch(error){
        console.error('Error:', error.response?.data || error)

        const message =
          error.response?.data?.message ||
          error.response?.data?.error ||
          'Failed to fetch telecaller'

        toast.error(message)
      }
    }

    useEffect(() => {
      fetchDonaionEnquiries()
      fetchTelecaller()
    },[token])
    console.log('Telecaller:', telecaller)

    const handleAssignTelecaller = async(enquiryId) => {
      const selectedTelecaller = selectedTelecallers[enquiryId]

      if(!selectedTelecaller){
        toast.error('Please select a telecaller')
        return
      }

      setLoading(true)

      try{
        const payload = {telecaller:selectedTelecaller}

        console.log('Enquiry Id:', enquiryId)
        console.log('Payload:', payload)

        const res = await axios.put(
          `${config.baseurl}update_donation_enquiries/${enquiryId}/`, payload, {
            headers: {
              'Content-Type':'application/json',
              'Authorization':`Token ${token}`
            }
          }
        )
        console.log('Update Donaion Enquiry:', res.data)

        if(res.status === 200){
          toast.success(res.data?.message || 'Telecaller assigned successfully')
          fetchDonaionEnquiries()
        }
      }catch(error){
        console.error('Error:',error.response?.data || error)

        const message = 
          error.response?.data?.message ||
          error.response?.data?.error ||
          'Failed to assign telecaller'

        toast.error(message)
      }finally{
        setLoading(false)
      }
    }
    console.log('all pending donation enquiries:', donEnq)

  return (
    <div className='min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 ml-64 5xl:ml-0'>
      <AdminHeader/>

      <div className='max-w-7xl mx-auto px-6 pt-16 pb-6 items-center justify-between text-center'>
        <h1 className='mt-1 text-3xl font-bold'>
          ALL Donation Enquiries
        </h1>
        <p className="mt-2 text-sm text-slate-500">
          View and manage all donation enquiries in one place.
        </p>
      </div>

      <div className='max-w-7xl mx-auto px-6 pb-10'>
        <div className='bg-white rounded-lg shadow-sm border border-slate-300 overflow-hidden'>
          <div className='overflow-x-auto'>
            <table className='w-full table-auto'>
              <thead>
                <tr className='text-center border-b border-slate-300'>
                  <th className='px-3 py-2 whitespace-nowrap'>No</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Name</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Email</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Phone Number</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Subject</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Message</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Telecaller</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Actions</th>
                </tr>
              </thead>

              <tbody>
                {donEnq.length > 0 ? (
                  donEnq.map((item, index) => (
                    <tr
                      key={item.id}
                      className='text-center border-b border-b-slate-300 cursor-pointer'
                    >
                      <td className='px-3 py-2 whitespace-nowrap'>{index + 1}</td>
                      <td className='px-3 py-2 whitespace-nowrap'>{item.name}</td>
                      <td className='px-3 py-2 whitespace-nowrap'>{item.email}</td>
                      <td className='px-3 py-2 whitespace-nowrap'>{item.phone}</td>
                      <td className='px-3 py-2 whitespace-nowrap'>{item.subject}</td>
                      <td className='px-3 py-2 whitespace-nowrap'>{item.message}</td>
                      <td className='px-3 py-2 whitespace-nowrap'>
                        <select
                          className="border border-slate-200 rounded-lg px-3 py-2"
                          value={selectedTelecallers[item.id] || item.telecaller?.id || ''}
                          onChange={(e) => {
                            setSelectedTelecallers((prev) => ({
                              ...prev,
                              [item.id]: e.target.value
                            }))
                          }}
                        >
                          <option value="">Select Telecaller</option>
                            {telecaller.map((item) => (
                              <option
                                key={item.id}
                                value={item.id}
                              >
                                {item.first_name} {item.last_name}
                              </option>
                          ))}
                        </select>
                      </td>
                      <td className='px-3 py-2 whitespace-nowrap'>
                        <div className='flex items-center justify-center gap-3'>
                          <button
                            title='Assign'
                            onClick={(e) => {
                                e.stopPropagation()
                                handleAssignTelecaller(item.id)
                            }}
                            className='bg-blue-500 text-white px-3 py-2 rounded-lg hover:bg-blue-600'
                          >
                            <FaUserCheck/>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={6}
                      className='text-center py-6'
                    >
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}
